export function removeEmptyValues(data: any) {
    return Object.entries(data).reduce((obj, [key, value]) => ({
        ...(Boolean(value) && { [key]: value}),
        ...obj,
    }), {});
}